import SportStatTypesList from "./SportStatTypesList";
export default SportStatTypesList;
